module.exports = __webpack_public_path__ + "static/media/Тезисы_УОМШ-2023, 1 том.1a6bd923.pdf";